var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMale3E(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 129,
    height: 124,
    viewBox: "0 0 129 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Male 3 E"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 106",
    cx: 60.0357,
    cy: 61.5,
    rx: 60.0357,
    ry: 61.5,
    fill: "#77311D"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle 1",
    filter: "url(#filter0_f_293_1218)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68 13.5L114 35.5L117.396 48.1802C124.263 73.8136 113.281 100.89 90.5 114.5L68 107V13.5Z",
    fill: "#B8B8B8",
    fillOpacity: 0.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 188"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 91",
    d: "M81.7506 42.7115C81.8378 42.0079 81.8052 41.3176 81.7051 40.6871C81.3932 38.722 79.5548 38.5321 77.9811 39.7497C77.4314 40.175 76.9604 40.6934 76.5895 41.2813L75 43.8008L74.5 52.3008L74.5325 52.291C75.1409 52.108 75.8 52.225 76.3083 52.6062L76.849 53.0117C77.2353 53.3015 78.1067 53.0271 78.5402 52.8145C78.8694 52.6531 78.8053 52.5761 79.0075 52.2702L79.3264 51.788C79.4088 51.6634 79.4781 51.5306 79.5332 51.3918L80.2171 49.6682C80.6005 48.3799 81.4439 45.185 81.7506 42.7115Z",
    fill: "#F4B09D",
    stroke: "#4F4848"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 97",
    d: "M34.5502 42.7115C34.463 42.0079 34.4955 41.3176 34.5956 40.6871C34.9076 38.722 36.746 38.5321 38.3197 39.7497C38.8694 40.175 39.3404 40.6934 39.7113 41.2813L41.3008 43.8008L41.8008 52.3008L41.7683 52.291C41.1599 52.108 40.5008 52.225 39.9925 52.6062L39.4518 53.0117C39.0655 53.3015 38.1941 53.0271 37.7606 52.8145C37.4313 52.6531 37.4955 52.5761 37.2933 52.2702L36.9744 51.788C36.892 51.6634 36.8227 51.5306 36.7676 51.3918L36.0837 49.6682C35.7003 48.3799 34.8569 45.185 34.5502 42.7115Z",
    fill: "#F4B09D",
    stroke: "#4F4848"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 93",
    d: "M44.8535 76.8356V63.5371L71.3061 63V65.1659V71.8114V77.6086V80.1898C71.3061 81.301 71.2069 82.4099 71.0097 83.5034L70.9004 84.1092C70.6609 85.4372 70.2351 86.7247 69.6355 87.9336L69.3332 88.5431C68.6124 89.9964 67.5853 91.2763 66.3225 92.2947C65.0595 93.3133 63.5907 94.0462 62.0172 94.4427L61.4343 94.5896C60.3522 94.8623 59.2406 95.0003 58.1247 95.0003H57.4498C55.4777 95.0003 53.5414 94.4731 51.8414 93.4734C50.5198 92.6962 49.3741 91.6528 48.4771 90.4094L47.8594 89.5531C47.1358 88.5502 46.5318 87.4663 46.0594 86.3234C45.2632 84.3971 44.8535 82.3332 44.8535 80.2489V76.8356Z",
    fill: "#F6C4A9",
    stroke: "#4F4848"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 90",
    d: "M41.0427 55.1641L40.6716 53.8279C40.1382 51.9074 39.7542 49.9484 39.5232 47.9686L39.1035 44.3726V40.1213V39.7978C39.1035 36.6692 39.36 33.5459 39.8703 30.4593L40.637 27.7539L40.854 26.806C41.4639 24.1417 42.8073 21.7012 44.7321 19.7607C45.577 18.909 46.5233 18.1644 47.5497 17.5435L47.7675 17.4118C50.3759 15.834 53.3662 15 56.4147 15H58.2721H62.7371C64.3491 15 65.9494 15.274 67.4696 15.8104C70.9169 17.0268 73.7635 19.5238 75.4187 22.7832L75.7025 23.3422C76.0938 24.1128 76.4212 24.9142 76.6814 25.7383L76.9381 26.5516C77.9693 29.8187 78.3487 33.2566 78.0547 36.6699L77.824 39.3483L76.6739 50.9428L76.2905 53.6481C75.526 56.7309 74.4285 59.7213 73.0173 62.5666L72.8401 62.9237L70.3494 66.5506C69.7118 67.4792 68.9705 68.3322 68.1401 69.0933C66.1969 70.8742 63.8149 72.1061 61.2384 72.6627L60.8635 72.7437C60.1602 72.8956 59.4427 72.9722 58.7232 72.9722C55.4664 72.9722 52.32 71.7914 49.8675 69.6485L49.2356 69.0965C48.3619 68.3332 47.5756 67.4753 46.891 66.5387L45.8859 65.1636C43.6827 62.1492 42.0419 58.7616 41.0427 55.1641Z",
    fill: "#F6C4A9",
    stroke: "#4F4848"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector 95"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.9128 60.2453L52.9068 61.762H62.8745L61.0594 60.1936C60.49 59.7016 59.8033 59.365 59.0656 59.2163C58.5423 59.1107 58.0041 59.102 57.4776 59.1905L57.2855 59.2227C56.4238 59.3675 55.6098 59.7183 54.9128 60.2453Z",
    fill: "url(#paint0_linear_293_1218)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.9068 61.762L54.9128 60.2453C55.6098 59.7183 56.4238 59.3675 57.2855 59.2227L57.4776 59.1905C58.0041 59.102 58.5423 59.1107 59.0656 59.2163V59.2163C59.8033 59.365 60.49 59.7016 61.0594 60.1936L62.8745 61.762H52.5234",
    stroke: "#4F4848",
    strokeWidth: 0.9
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector 94",
    d: "M55 53V53C56.3569 54.7587 59.0103 54.7587 60.3672 53V53",
    stroke: "#4F4848",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 96",
    d: "M56.3535 63.3105L56.533 63.4915C57.4573 64.4233 58.988 64.3386 59.8039 63.3105V63.3105",
    stroke: "#4F4848"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 189"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 109",
    d: "M80.8828 43.7169C80.8828 44.2692 80.3828 42.7168 79.8828 42.7175C79.3828 42.2168 78.748 42.2684 78.748 41.7161C78.748 41.1638 79.3828 40.717 79.8828 41.2174C80.4351 41.2174 80.8828 43.1646 80.8828 43.7169Z",
    fill: "#606060"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 110",
    d: "M77.5409 50.7164C77.3825 50.2168 77.7246 47.8711 77.8828 46.7168C77.8828 45.3711 78.5409 43.7168 79.0409 43.7168C80.0026 43.7168 79.9499 45.2251 79.7443 46.1645C79.329 48.0619 78.1838 50.7167 77.5409 50.7164Z",
    fill: "#6B6B6B"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 116",
    d: "M38.4453 43.136C38.4453 47.6367 39.9453 49.6367 39.9449 50.636C39.4453 51.6367 36.9449 46.9122 36.9449 46.636C36.9449 46.3599 35.9436 43.6366 36.9453 42.136C37.9436 41.6365 38.447 42.6368 38.4453 43.136Z",
    fill: "#606060"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 113",
    opacity: 0.5,
    filter: "url(#filter1_f_293_1218)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 58,
    cy: 62.5,
    rx: 1,
    ry: 0.5,
    fill: "#DC2F2F",
    fillOpacity: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 192"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M51 42.0005C51 42.1316 50.9904 42.2616 50.9711 42.3906C50.9519 42.5186 50.923 42.6445 50.8858 42.7651C50.8473 42.8869 50.8019 43.0013 50.7469 43.1105C50.6919 43.2198 50.63 43.3207 50.5598 43.4143C50.4911 43.5069 50.4154 43.5901 50.3329 43.6629C50.2517 43.7358 50.1651 43.7971 50.0743 43.8471C49.9835 43.898 49.8886 43.9355 49.7923 43.9615C49.696 43.9865 49.5983 44 49.4993 44C49.4017 44 49.304 43.9865 49.2077 43.9615C49.11 43.9355 49.0165 43.898 48.9257 43.8471C48.8349 43.7971 48.7483 43.7358 48.6657 43.6629C48.5846 43.5901 48.5089 43.5069 48.4388 43.4143C48.37 43.3207 48.3067 43.2198 48.2531 43.1105C48.1981 43.0013 48.1513 42.8869 48.1142 42.7651C48.0757 42.6445 48.0481 42.5186 48.0289 42.3906C48.0096 42.2616 48 42.1316 48 42.0005C48 41.8684 48.0096 41.7384 48.0289 41.6104C48.0481 41.4814 48.0757 41.3566 48.1142 41.2349C48.1513 41.1131 48.1981 40.9987 48.2531 40.8895C48.3067 40.7802 48.37 40.6793 48.4388 40.5857C48.5089 40.4931 48.5846 40.4109 48.6657 40.3371C48.7483 40.2642 48.8349 40.2029 48.9257 40.1529C49.0165 40.102 49.11 40.0645 49.2077 40.0385C49.304 40.0135 49.4017 40 49.4993 40C49.5983 40 49.696 40.0135 49.7923 40.0385C49.8886 40.0645 49.9835 40.102 50.0743 40.1529C50.1651 40.2029 50.2517 40.2642 50.3329 40.3371C50.4154 40.4109 50.4911 40.4931 50.5598 40.5857C50.63 40.6793 50.6919 40.7802 50.7469 40.8895C50.8019 40.9987 50.8473 41.1131 50.8858 41.2349C50.923 41.3566 50.9519 41.4814 50.9711 41.6104C50.9904 41.7384 51 41.8684 51 42.0005Z",
    fill: "#070200"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M70 42.0005C70 42.1316 69.9904 42.2616 69.9711 42.3906C69.9519 42.5186 69.923 42.6445 69.8858 42.7651C69.8473 42.8869 69.8019 43.0013 69.7469 43.1105C69.6919 43.2198 69.63 43.3207 69.5598 43.4143C69.4911 43.5069 69.4154 43.5901 69.3329 43.6629C69.2517 43.7358 69.1651 43.7971 69.0743 43.8471C68.9835 43.898 68.8886 43.9355 68.7923 43.9615C68.696 43.9865 68.5983 44 68.4993 44C68.4017 44 68.304 43.9865 68.2077 43.9615C68.11 43.9355 68.0165 43.898 67.9257 43.8471C67.8349 43.7971 67.7483 43.7358 67.6657 43.6629C67.5846 43.5901 67.5089 43.5069 67.4388 43.4143C67.37 43.3207 67.3067 43.2198 67.2531 43.1105C67.1981 43.0013 67.1513 42.8869 67.1142 42.7651C67.0757 42.6445 67.0481 42.5186 67.0289 42.3906C67.0096 42.2616 67 42.1316 67 42.0005C67 41.8684 67.0096 41.7384 67.0289 41.6104C67.0481 41.4814 67.0757 41.3566 67.1142 41.2349C67.1513 41.1131 67.1981 40.9987 67.2531 40.8895C67.3067 40.7802 67.37 40.6793 67.4388 40.5857C67.5089 40.4931 67.5846 40.4109 67.6657 40.3371C67.7483 40.2642 67.8349 40.2029 67.9257 40.1529C68.0165 40.102 68.11 40.0645 68.2077 40.0385C68.304 40.0135 68.4017 40 68.4993 40C68.5983 40 68.696 40.0135 68.7923 40.0385C68.8886 40.0645 68.9835 40.102 69.0743 40.1529C69.1651 40.2029 69.2517 40.2642 69.3329 40.3371C69.4154 40.4109 69.4911 40.4931 69.5598 40.5857C69.63 40.6793 69.6919 40.7802 69.7469 40.8895C69.8019 40.9987 69.8473 41.1131 69.8858 41.2349C69.923 41.3566 69.9519 41.4814 69.9711 41.6104C69.9904 41.7384 70 41.8684 70 42.0005Z",
    fill: "#070200"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M43.4476 37L43 36.0897C48.6527 31.8257 54.7408 35.3819 55 35.537L54.6253 36.4948C54.5646 36.4573 48.6911 33.0361 43.4476 37Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M73.5484 37C68.3028 33.0436 62.4294 36.4573 62.3747 36.4948L62 35.537C62.2572 35.3819 68.3453 31.8257 74 36.0897L73.5484 37Z",
    fill: "#231F20"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 207"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M80.5 38.5C76.5 38 77.181 45 77.181 45H75.6337C75.6337 45 76.1353 38.2012 74.9574 35.3056C73.7766 32.4087 74.1475 27.7646 74.1475 27.7646C74.1475 27.7646 71.9551 29.2349 62.6029 29.7465C53.2479 30.2582 46.7503 24.0651 43.4851 25.9781C40.2143 27.8968 42.6696 34.9135 41.8938 36.8321C41.1165 38.7451 41.5 44.5 41.5 44.5H39.5C39.5 44.5 39.6449 42.9987 39.5 41C39.3494 38.9998 36.5 38.5 36.5 38.5C36.2272 37.1169 36 26.1482 36 22.1465C36 18.1448 39.8307 17.6781 39.8307 17.6781C39.8307 17.6781 40.0807 16.5073 41.341 15.0244C42.455 13.7101 44.3547 12.1499 47.5758 10.9481C50.6051 9.81805 54.7981 9 60.6009 9C71.4081 9 76.3683 14.427 78.5096 20.6102C78.9472 21.8626 79.2655 23.1445 79.4914 24.4179C80.7574 31.4656 80.5 38.5 80.5 38.5Z",
    fill: "#4B3222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M62.4494 56.1625C60.2376 56.0316 57.9984 56 57.9984 56C57.9984 56 55.7622 56.0345 53.546 56.1625C50.6932 56.3307 49.5262 57.5171 49.0519 58.3943C48.878 58.7164 49.1683 59.0889 49.5161 58.981C52.0068 58.1987 57.9984 58.505 57.9984 58.505C57.9984 58.505 63.9901 58.1987 66.4793 58.981C66.8156 59.086 67.1188 58.7279 66.9535 58.4159C66.4893 57.5387 65.3252 56.3336 62.4494 56.1625Z",
    fill: "#070200"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M79 24.8334C78.257 24.9835 77.5196 25.112 76.7851 25.2261C75.6571 25.4441 73.8937 25.6434 72.7304 25.7545C72.1614 25.8498 71.2712 25.8773 70.681 25.9076L68.6204 26C67.9128 25.9942 66.1833 25.9538 65.4997 25.9408C63.4929 25.7906 61.2157 25.5668 59.2386 25.1308C52.2825 23.7649 45.9308 20.2348 41 15.1871C42.1096 13.8371 44.0018 12.2345 47.2102 11C47.4083 11.231 47.6065 11.4548 47.8145 11.6786C51.4645 15.6506 56.3118 18.365 61.4775 19.7987C62.8942 20.1972 64.5458 20.5105 65.9838 20.7589C66.5923 20.8267 68.1378 21.0014 68.7619 21.0693C69.3507 21.0967 71.0023 21.1805 71.5769 21.2079C73.0431 21.1949 74.8603 21.2021 76.3166 21.0578C76.8842 21.0231 77.4559 20.9769 78.0249 20.922C78.458 22.2056 78.7778 23.5253 79 24.8334Z",
    fill: "#5E3F2B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M77 17.5C77 17 76.065 17.3487 75.6011 17.4324C74.8887 17.5922 73.775 17.7384 73.0402 17.8199C72.6809 17.8898 72.1187 17.9099 71.7459 17.9321L70.4445 17.9999C69.9975 17.9956 68.9053 17.966 68.4735 17.9565C67.206 17.8464 65.7678 17.6822 64.5191 17.3625C60.1258 16.3608 55.6142 13.2016 52.5 9.5C54.5 9.00006 57 8.99995 59 8.99995C58.8686 8.83583 59.1251 9.16936 59 8.99995C61.3053 11.9127 62.6706 12.4009 65.9332 13.4523C66.8279 13.7445 67.8711 13.9743 68.7792 14.1564C69.1636 14.2062 70.1397 14.3343 70.5339 14.384C70.9057 14.4042 71.9488 14.4656 72.3117 14.4857C73.2378 14.4762 73.13 14.4899 74.0498 14.384C74.4082 14.3586 74.5 14 74.5 14C75 14.5 76.8597 16.5407 77 17.5Z",
    fill: "#5E3F2B"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 117",
    d: "M71 66.0399C71 69.4867 67.2529 74.6671 61.0436 77.0586C58.9248 77.8746 56.5564 77.9135 54.433 77.1097C47.6976 74.5599 45 68.4954 45 65C46.0196 66.1774 50.6078 73.0842 57.2353 73.3194C64.8824 73.5909 68.9608 69.1597 71 66.0399Z",
    fill: "#655E5E",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 194"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 114",
    filter: "url(#filter2_f_293_1218)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M109 94.9997C106 106 84.2978 123 60.1502 123C36.0026 123 17 107.501 10 93.0014C59 69.5 32.5 71.0009 57.5 93.0009C84 74.4997 52.5 67.4997 109 94.9997Z",
    fill: "#F4D150"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector 101"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.5646 77.9825L42.7237 74.17C43.291 73.6499 44.2086 73.9388 44.3756 74.6902L44.9497 77.2735C44.9828 77.4225 45.0496 77.562 45.145 77.6812L51 85L57.5 89.5L63.5 85L71.2747 77.7112C71.4215 77.5736 71.5233 77.395 71.567 77.1986L72.0815 74.8832C72.2574 74.0918 73.2523 73.8276 73.7976 74.4274L77.0173 77.969C77.3058 78.2864 77.3598 78.7524 77.1515 79.1273L70.6848 90.7674C70.3502 91.3697 69.521 91.4611 69.0632 90.9461L66 87.5L57.5 93.5L48.8571 87.5L45.9647 90.8745C45.5033 91.4128 44.644 91.3134 44.3177 90.6841L38.3526 79.1799C38.1445 78.7787 38.2314 78.2878 38.5646 77.9825Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51 85L48.8571 87.5M51 85L57.5 89.5M51 85L45.145 77.6812C45.0496 77.562 44.9828 77.4225 44.9497 77.2735L44.3756 74.6902C44.2086 73.9388 43.291 73.6499 42.7237 74.17L38.5646 77.9825C38.2314 78.2878 38.1445 78.7787 38.3526 79.1799L44.3177 90.6841C44.644 91.3134 45.5033 91.4128 45.9647 90.8745L48.8571 87.5M48.8571 87.5L57.5 93.5M57.5 93.5L66 87.5M57.5 93.5V89.5M66 87.5L69.0632 90.9461C69.521 91.4611 70.3502 91.3697 70.6848 90.7674L77.1515 79.1273C77.3598 78.7524 77.3058 78.2864 77.0173 77.969L73.7976 74.4274C73.2523 73.8276 72.2574 74.0918 72.0815 74.8832L71.567 77.1986C71.5233 77.395 71.4215 77.5736 71.2747 77.7112L63.5 85M66 87.5L63.5 85M63.5 85L57.5 89.5",
    stroke: "black"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M63 122.5H53.5C53.8043 108.811 56.6835 100.945 56.6835 100.945C56.547 100.885 56.3205 100.626 56.0543 100.251V100.25C56.472 100.315 57.0342 100.349 57.5733 100.349C58.3294 100.349 59.0364 100.281 59.2179 100.129C59.4799 99.9075 61.3851 92.727 62.0538 91L63.5 90C62.8531 91.5944 60.584 100.749 60.352 100.945L60.3206 100.968C60.4612 101.525 62.7038 109.103 63 122.5Z",
    fill: "#D0C5D8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M62.5 122.5H53.5C53.6465 111.19 56.2613 101 56.2613 101H59.1723L59.1778 101.015C59.2871 101.465 62.3557 111.422 62.5 122.5Z",
    fill: "#15355E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M53.5 91C53.5 91 55.6432 100.625 56.1902 100.832C56.7359 101.039 58.9851 101.072 59.306 100.832C59.627 100.592 61.8065 91.9279 62 91C61.5 90.9992 57.5 94 57.5 94L53.5 91Z",
    fill: "#15355E"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_293_1218",
    x: 67,
    y: 12.5,
    width: 53.4238,
    height: 103,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "effect1_foregroundBlur_293_1218"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_293_1218",
    x: 56.6,
    y: 61.6,
    width: 2.8,
    height: 1.8,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.2,
    result: "effect1_foregroundBlur_293_1218"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_293_1218",
    x: 9,
    y: 74.9336,
    width: 101,
    height: 49.0664,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "effect1_foregroundBlur_293_1218"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_293_1218",
    x1: 58.274,
    y1: 59.4431,
    x2: 58.274,
    y2: 62.1485,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F31E1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D1111"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMale3E);
export default __webpack_public_path__ + "static/media/Male 3 E.5c61d14cd1e432070d81a9f6bc17f7d1.svg";
export { ForwardRef as ReactComponent };